module.exports = __webpack_public_path__ + "static/media/mssg_getstartedresponse_pt_BR.b5efb9e5.png";